/** Formatação dos badges de escopo (NCM e Produto), compartilhada entre a etapa de Escopo e a Revisão. */

export interface EscopoProdutoBadge {
    codigo: string;
    descricao?: string;
    sku?: string;
}

/** Formata o NCM por comprimento: ≤4 cru; 5-6 → NNNN.NN; 7-8 → NNNN.NN.NN. */
export function formatNcm(codigo: string): string {
    const d = (codigo || '').replace(/\D/g, '');
    if (d.length <= 4) return d;
    if (d.length <= 6) return `${d.slice(0, 4)}.${d.slice(4)}`;
    return `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6)}`;
}

/** Rótulo do produto no badge: "SKU - Nome" (ou só o nome/SKU disponível); nunca o id interno. */
export function badgeLabel(item: EscopoProdutoBadge): string {
    const sku = (item.sku ?? '').trim();
    const nome = (item.descricao ?? '').trim();
    if (sku && nome && nome !== sku) return `${sku} - ${nome}`;
    if (sku) return sku;
    if (nome && nome !== item.codigo) return nome;
    return item.codigo;
}

/**
 * Retorna o NCM da lista que já cobre `novo` (prefixo estrito e mais curto — ex.: "72" cobre
 * "7208"), ou null se nenhum cobrir.
 */
export function ncmMaisGenericoQueCobre(novo: string, existentes: string[]): string | null {
    return existentes.find(e => e.length < novo.length && novo.startsWith(e)) ?? null;
}

/** Retorna os NCMs da lista que passam a ser redundantes porque `novo` é mais genérico e os cobre. */
export function ncmsQueSeTornamRedundantes(novo: string, existentes: string[]): string[] {
    return existentes.filter(e => novo.length < e.length && e.startsWith(novo));
}
